import React, { useState } from 'react';
import AppSidebar from '../AppSidebar';
import AppHeader from '../AppHeader';
import AppFooter from '../AppFooter';
import AppContent from '../AppContent';

const DefaultLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="wrapper">
      <AppSidebar isCollapsed={isSidebarCollapsed} />
      <div className="main">
        <AppHeader toggleSidebar={() => setIsSidebarCollapsed(c => !c)} />
        <div className="content">
          <AppContent />
        </div>
        <AppFooter />
      </div>
    </div>
  );
};

export default DefaultLayout;
